import React, { useState } from "react";
import { motion } from "framer-motion";

const ContactSection = ({ isFullPage = false }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    alert("Thanks for reaching out! I’ll get back to you shortly.");
    setFormData({ name: "", email: "", message: "" });
  };

  // Animation variants
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const fieldVariants = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  return (
    <section
      id="contact"
      className={`relative py-24 ${isFullPage ? "min-h-screen flex items-center" : ""}`}
    >
      {/* Background glow */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/3 left-24 w-72 h-72 bg-blue-500/15 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-24 w-72 h-72 bg-red-500/15 rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-6">
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Get in <span className="gradient-text">Touch</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Have a project in mind, a question, or want to collaborate?
            Fill out the form below and let’s build something impactful together.
          </p>
        </motion.div>

        {/* Form */}
        <motion.form
          onSubmit={handleSubmit}
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="glass rounded-2xl p-8 md:p-10 space-y-6"
        >
          <motion.div variants={fieldVariants}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-5 py-4 rounded-xl bg-black/40 
                         border border-white/10 text-white 
                         placeholder-gray-500 focus:outline-none 
                         focus:border-blue-500 transition-all"
            />
          </motion.div>

          <motion.div variants={fieldVariants}>
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-5 py-4 rounded-xl bg-black/40 
                         border border-white/10 text-white 
                         placeholder-gray-500 focus:outline-none 
                         focus:border-blue-500 transition-all"
            />
          </motion.div>

          <motion.div variants={fieldVariants}>
            <textarea
              name="message"
              rows="5"
              placeholder="Tell me about your project..."
              value={formData.message}
              onChange={handleChange}
              required
              className="w-full px-5 py-4 rounded-xl bg-black/40 
                         border border-white/10 text-white 
                         placeholder-gray-500 focus:outline-none 
                         focus:border-blue-500 transition-all resize-none"
            />
          </motion.div>

          <motion.button
            type="submit"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="w-full py-4 rounded-xl font-medium text-white
                       bg-gradient-to-r from-blue-500 via-red-500 to-orange-500
                       shadow-glowBlue transition-all"
          >
            Send Message 
          </motion.button>
        </motion.form>
      </div>
    </section>
  );
};

export default ContactSection;
